import React from "react";
import { Box, Button, Typography, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import StepProgress from './StepProgress';
import { useAuth } from "../context/AuthContext";
import gb from '../assets/images/gbottom.png';

const PaymentScreen = () => {
    const { user } = useAuth();
    const navigate = useNavigate();

    return (
        <Box sx={{ backgroundColor: "#f8f9e9", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", py: 6, position: "relative" }}> 
            {/* Step Indicator */}
            <StepProgress />

            {/* Payment Info */}
            <Typography variant="h6" className="text-[#E52029] py-6 font-semibold mb-3">
                To pay 2000 Rs
            </Typography>

            {/* Proceed Payment Button */}
            <Button
                variant="contained"
                className="bg-green-500 text-white px-6 py-6 rounded-lg"
                style={{ backgroundColor: "#28A745", color: "white" }}
                onClick={() => navigate("/paymentgateway2")}
            >
                Proceed Payment
            </Button>

            {/* Contact Admin Info */}
            <Typography variant="h6" className="text-[#E52029] py-6 text-center mt-4 text-sm">
                If you want to pay above or below, contact district agent Admin
            </Typography>
            <Typography variant="h6" className="text-black text-lg font-semibold">
                <strong>Admin details</strong>
            </Typography>

            {/* Admin Details Card */}
            <Box className="mt-6 mb-6 border border-yellow-500 rounded-md py-6 p-4 w-100 bg-[#f8f9e9]">
                <Typography variant="h6" className="text-black text-md mt-2 text-left">
                    <strong>Name: </strong>{user?.firstName}
                </Typography>
                <Typography variant="h6" className="text-black text-md text-left">
                    <strong>District: </strong>Madurai
                </Typography>
                <Typography variant="h6" className="text-black text-md text-left">
                    <strong>Contact no: </strong> {user?.Mobile_Number}
                </Typography>
            </Box>

            {/* Back Button */}
            <Button
                variant="contained"
                className="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-lg"
                style={{ backgroundColor: "#E52029", color: "white" }}
                onClick={() => navigate("/profile")}
            >
                Back
            </Button>

            {/* Footer Image - Positioned on the Bottom Left */}
            <Box
                sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "400px", // Adjust width as needed
                    height: "150px", // Adjust height as needed
                    backgroundImage: `url(${gb})`,
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "left bottom",// Keeps it behind the content
                    zIndex:0,
                }}
            />
        </Box>
    );
};

export default PaymentScreen;
